import BIAnchorDate from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-anchor/bi-anchor-date.vue';
import BIAnchorPeriod from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-anchor/bi-anchor-period.vue';
import BIBetweenInputDate from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-between-input/bi-between-input-date.vue';
import BIBetweenInputNumber from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-between-input/bi-between-input-number.vue';
import BIInputDate from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-input/bi-input-date.vue';
import BIInputNumber from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-input/bi-input-number.vue';
import BIInputText from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-input/bi-input-text.vue';
import BIMultiSelectCheckbox from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-multi-select/bi-multi-select-checkbox.vue';
import BINone from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-none.vue';
import BISelectRelativeDate from '~/bi/components/filters/bi-filter-list/bi-filter/operator-input-components/bi-select/bi-select-relative-date.vue';
import { OPERATORS_CONFIG_MAP } from '~/bi/constants/bi-constants';

export function useBIFilterMaps() {
  // Contains mapping of value types and field types to components and their configurations
  const value_type_map_field_component = {
    input: {
      text: {
        component: BIInputText,
        componentConfig: {},
      },
      integer: {
        component: BIInputNumber,
        componentConfig: {},
      },
      float: {
        component: BIInputNumber,
        componentConfig: {},
      },
      date: {
        component: BIInputDate,
        componentConfig: {
          options: {
            placeholder: 'Select date',
            format: 'dd-MM-yyyy',
            range: false,
          },
        },
      },
      timestamp: {
        component: BIInputDate,
        componentConfig: {
          options: {
            placeholder: 'Select date',
            format: 'dd-MM-yyyy',
            range: false,
            // format: 'dd-MM-yyyy h:mm a',
            // timePicker: true,
            // is24: false,
            // enableTimePicker: true,
          },
        },
      },
    },
    select: {
      date: {
        component: BISelectRelativeDate,
        componentConfig: {},
      },
      timestamp: {
        component: BISelectRelativeDate,
        componentConfig: {},
      },
    },
    multi_select: {
      text: {
        component: BIMultiSelectCheckbox,
        componentConfig: {},
      },
      integer: {
        component: BIMultiSelectCheckbox,
        componentConfig: {},
      },
      float: {
        component: BIMultiSelectCheckbox,
        componentConfig: {},
      },
      date: {
        component: BIMultiSelectCheckbox,
        componentConfig: {},
      },
      timestamp: {
        component: BIMultiSelectCheckbox,
        componentConfig: {},
      },
      array: {
        component: BIMultiSelectCheckbox,
        componentConfig: {},
      },
    },
    range_input: {
      integer: {
        component: BIBetweenInputNumber,
        componentConfig: {},
      },
      date: {
        component: BIBetweenInputDate,
        componentConfig: {
          options: {
            min_options: {
              placeholder: 'Start date',
              range: false,
              format: 'dd-MM-yyyy',
              // enableTimePicker: true,
            },
            max_options: {
              placeholder: 'End date',
              range: false,
              format: 'dd-MM-yyyy',
              // enableTimePicker: true,
            },
          },
        },
      },
      timestamp: {
        component: BIBetweenInputDate,
        componentConfig: {
          options: {
            min_options: {
              placeholder: 'Start date',
              format: 'dd-MM-yyyy',
              range: false,
              // format: 'dd-MM-yyyy h:mm a',
              // timePicker: true,
              // is24: false,
              // enableTimePicker: true,
            },
            max_options: {
              placeholder: 'End date',
              format: 'dd-MM-yyyy',
              range: false,
              // format: 'dd-MM-yyyy h:mm a',
              // timePicker: true,
              // is24: false,
              // enableTimePicker: true,
            },
          },
        },
      },
    },
    anchor_date: {
      date: {
        component: BIAnchorDate,
        componentConfig: {},
      },
      timestamp: {
        component: BIAnchorDate,
        componentConfig: {},
      },
    },
    anchor_period: {
      date: {
        component: BIAnchorPeriod,
        componentConfig: {},
      },
      timestamp: {
        component: BIAnchorPeriod,
        componentConfig: {},
      },
    },
  };

  function getTypeOperatorMap() {
    return Object.entries(OPERATORS_CONFIG_MAP).reduce((acc, [_key, config]) => {
      config.supportedTypes.forEach((type) => {
        if (!acc[type]) {
          acc[type] = [];
        }
        acc[type].push(config.name);
      });
      // Add mapping for supported resource types as well
      config.supportedResourceTypes?.forEach((type) => {
        if (!acc[type]) {
          acc[type] = [];
        }
        acc[type].push(config.name);
      });
      return acc;
    }, {});
  }

  function getOperatorComponent({ selected_operator, selected_column_config }) {
    if (selected_operator?.component === 'none') {
      return {
        component: BINone,
        componentConfig: {},
      };
    }
    else {
      const component_data = value_type_map_field_component[selected_operator?.component]?.[selected_column_config.type];

      if (!component_data?.columnConfig) {
        component_data.columnConfig = {};
      }
      if (!component_data?.operatorConfig) {
        component_data.operatorConfig = {};
      }
      component_data.columnConfig = { ...selected_column_config };
      component_data.operatorConfig = { ...selected_operator };

      return value_type_map_field_component[selected_operator?.component]?.[selected_column_config.type];
    }
  }

  return {
    getTypeOperatorMap,
    getOperatorComponent,
  };
}
